import { TranslateService } from "@ngx-translate/core";
import { SECAuth, Parameter } from "./../../models/login";
import { first, map } from "rxjs/operators";
import {
  Component,
  ElementRef,
  Inject,
  Input,
  OnInit,
  ViewEncapsulation,
} from "@angular/core";
import Keyboard from "simple-keyboard";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { AccountService } from "src/app/services/account.service";
import Swal from "sweetalert2";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
  selector: "app-twfa",
  encapsulation: ViewEncapsulation.None,
  templateUrl: "./twfa.component.html",
  styleUrls: ["./twfa.component.scss"],
})
export class TwfaComponent implements OnInit {
  value = "";
  secAuthReq: SECAuth = {} as SECAuth;
  token: any;
  ordinalNum: number;
  keyboard: Keyboard;
  passCount: any;
  carItems: any;
  arrayCount: number[] = [];
  tfa: any;
  // userName: any;
  // password: any;
  input: HTMLInputElement;
  firstInput: any;
  focus: any;
  remeberMe: boolean;


  constructor(
    @Inject(MAT_DIALOG_DATA) public data: string,
    private accountService: AccountService,
    private elementRef: ElementRef<HTMLInputElement>,
    private route: ActivatedRoute,
    private router: Router,
    public dialogRef: MatDialogRef<TwfaComponent>,
    public translate: TranslateService
  ) {
    if (this.data["data"] != null) {
      this.tfa = this.data["data"];
    }
    if (this.data["remeberMe"] != null) {
      this.remeberMe = this.data["remeberMe"];
    }
     this.translate = translate
  }

  ngOnInit(): void {
    this.passCount = this.tfa.secondParameter.maxCount;
    this.carItems = this.tfa.secondParameter.Items;
    if (this.passCount != null) {
      for (let i = 0; i < this.passCount; i++) this.arrayCount.push(i);
    }
  }

  ngAfterViewInit() {
    this.onInputFocus();
    this.elementRef.nativeElement.focus();
  }

onInputFocus() {
  const isArabic = this.isArabic;

  this.keyboard = new Keyboard({
    onKeyPress: (button) => this.onKeyPress(button),
    onInputChange: (event) => this.onInputChange(event),
    layout: {
      default: isArabic
        ? [
            "١ ٢ ٣",
            "٤ ٥ ٦",
            "٧ ٨ ٩",
            "{bksp} ٠"
          ]
        : [
            "1 2 3",
            "4 5 6",
            "7 8 9",
            "0 {bksp}"
          ]
    },
    display: {
      "{bksp}": isArabic ? "حذف" : "⌫"
    },
    theme: `hg-theme-default hg-layout-numeric numeric-theme ${
      isArabic ? "hg-rtl" : ""
    }`
  });
}


  onKeyPress = (button: string) => {
    /**
     * If you want to handle the shift and caps lock buttons
     */ if (button === "{bksp}") {
      this.keyboard.clearInput();
    } else {
      this.value = button;
    }

    if (button === "{shift}" || button === "{lock}") this.handleShift();
  };

  onInputChange = (event: any) => {
    this.keyboard.setInput(event.target.value);
  };

  handleShift = () => {
    let currentLayout = this.keyboard.options.layoutName;
    let shiftToggle = currentLayout === "default" ? "shift" : "default";

    this.keyboard.setOptions({
      layoutName: shiftToggle,
    });
  };

  putOrdinalNum(index, e) {
    this.ordinalNum = Number(index);
  }
onPropertyChange(index, e) {
  e.target.value = this.value;

  if (e.target.value !== "") {

    const displayValue = e.target.value;

    // Convert Arabic digit → English before sending
    const apiValue = this.isArabic
      ? this.arabicToEnglishDigits(displayValue)
      : displayValue;

    this.carItems.map((item, i) => {
      if (item.Index == index) {
        this.carItems[i].Value = apiValue; // 👈 ENGLISH ONLY
      }
    });

    const target = e.target as HTMLElement;
    let nextNode: Node = target.nextSibling;

    while (
      nextNode &&
      (!(nextNode instanceof HTMLInputElement) ||
        (nextNode as HTMLInputElement).disabled)
    ) {
      nextNode = nextNode.nextSibling;
    }

    const nextElement = nextNode as HTMLInputElement | null;
    if (nextElement) {
      nextElement.focus();
      nextElement.select();
    }

    this.value = "";
  }
}

private arabicToEnglishDigits(value: string): string {
  const arabicDigits = '٠١٢٣٤٥٦٧٨٩';
  const englishDigits = '0123456789';

  return value.replace(/[٠-٩]/g, (d) =>
    englishDigits[arabicDigits.indexOf(d)]
  );
}

  // trackByIndex(index: number, obj: any): any {
  //   return index;
  // }
  submitSecAuth() {
    this.secAuthReq.UserName = this.tfa.Username;
    this.secAuthReq.Token = this.tfa.Token;
    this.secAuthReq.RefreshToken = this.tfa.RefreshToken ?? null;
    this.secAuthReq.Parameter = {} as Parameter;
    this.secAuthReq.Parameter.maxCount = Number(this.passCount);
    this.secAuthReq.Parameter.Items = this.carItems;

    if (this.secAuthReq) {
      this.accountService
        .checkSecondAuth(this.secAuthReq)
        .pipe(first())
        .subscribe({
          next: (userToken) => {
            // if (userToken) {
            //   var decoded = jwt_decode(userToken.toString());

            //   // let isMarket = decoded["unique_name"].split("_")[3];

            //   // let isDemo = decoded["unique_name"].split("_")[4];

            //   // if (isMarket == "1")
            //   //   //set is Market
            //   //   this.accountService.setIsFullMarket(true);
            //   // //set not is Market
            //   // else if (isMarket == "0")
            //   //   this.accountService.setIsFullMarket(false);
            // }

            // get return url from query parameters or default to home page
            this.accountService
              .getAccountList(userToken["Token"])
              .subscribe((res) => {
                localStorage.setItem("accList", JSON.stringify(res));
                this.accountService.saveUserProfile(res[0].relationCode);
                const returnUrl =
                  this.route.snapshot.queryParams["returnUrl"] || "/";
                this.router.navigateByUrl("/");

                this.dialogRef.close();
              });
          },
          error: (err) => {
            Swal.fire({
              position: "center",
              icon: "error",
              title: this.translate.instant("second-login-failed-msg"),
              showConfirmButton: false,
              timer: 4500,
            });
          },
        });
    }
  }
      // Getter to check if current language is Arabic
    public get isArabic(): boolean {
        return this.translate.currentLang === 'ar';
    }

    // Getter to get current language
    public get currentLang(): string {
        return this.translate.currentLang || this.translate.defaultLang || 'en';
    }

    // Getter to check if current language is English
    public get isEnglish(): boolean {
        return this.translate.currentLang === 'en';
    }
}
